import { siteConfig } from "../data/mock";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 px-6 border-t border-white/5">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="font-mono text-sm text-[#6B7280]">
          © {currentYear} {siteConfig.name}. All rights reserved.
        </div>
        <div className="font-mono text-xs text-[#6B7280]/60">
          Backing founders with conviction. Building for human flourishing.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
